import styled from 'styled-components'
import type { FunctionComponent } from 'react'
import DataCard, { DataList } from '../../shared/components/DataCard'
import { NoDataSearchResults } from '../../shared/components/NoSearchResults'
import type { DataIconType } from '../../shared/components/DataCard/DataIcon'
import type { DataResult } from './types'

const CardWrapper = styled.div<{ compact: boolean }>`
  width: 100%;
  margin-bottom: ${({ compact }) => (compact ? '0.5rem' : '2rem')};
`

export interface CombinedDataResult {
  count: number
  label: string
  results: DataResult[]
  type: DataIconType
  __typename: 'CombinedDataResult'
}

export interface DataSearchResultsProps {
  query: string
  results: CombinedDataResult[]
  compact: boolean
  withPagination: boolean
}

const DataSearchResults: FunctionComponent<DataSearchResultsProps> = ({
  query,
  results,
  compact,
  withPagination,
}) => {
  const Card = compact ? DataCard : DataList

  // Get the total count for all data types
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  const totalCount = results.reduce((acc, { count }) => acc + count, 0)

  return totalCount > 0 ? (
    <>
      {results.map((result) => {
        return result.results && result.results.length > 0 ? (
          <CardWrapper key={result.type} compact={compact}>
            <Card {...{ ...result, withPagination, query }} />
          </CardWrapper>
        ) : null
      })}
    </>
  ) : (
    <NoDataSearchResults data-testid="noResults" query={query} unauthorized={[]} />
  )
}
export default DataSearchResults
